export const ServicePolicyMap = {
  POSTHOG: "analytical-cookies",
  GLEAP: "analytical-cookies",
  HUBSPOT: "analytical-cookies",
} as const;
